import { render, staticRenderFns } from "./tan_from_to.vue?vue&type=template&id=cb5816f2&scoped=true"
import script from "./tan_from_to.vue?vue&type=script&lang=js"
export * from "./tan_from_to.vue?vue&type=script&lang=js"
import style0 from "./tan_from_to.vue?vue&type=style&index=0&id=cb5816f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5816f2",
  null
  
)

export default component.exports